import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';

@Component({
  selector: 'bui-pagination',
  template:`<ul class="ant-pagination"  [class.mini]="nzSize==='small'" *ngIf="!simpleType">
  <li class="ant-pagination-prev" [class.ant-pagination-disabled]="_currentPage===1" title="上一页"
  (click)="_jump2Page(_currentPage-1)">
    <a></a>
  </li>
  <li class="ant-pagination-item" title="第一页"
      [class.ant-pagination-item-active]="_currentPage===1" 
      (click)="_jump2Page(1)">
    <a>1</a>
  </li>
  <li *ngIf="_isShowJumpPrev" class="ant-pagination-jump-prev" title="向前 {{_pageSizeHalf}} 页"
    (click)="_jump2Page(_currentPage - _pageSizeHalf)">
    <a></a>
  </li>
  <li *ngFor="let page of _renderPages" class="ant-pagination-item" title="{{page}}"
      [class.ant-pagination-item-active]="_currentPage===page" 
      (click)="_jump2Page(page)">
    <a>{{page}}</a>
  </li>
  <li *ngIf="_isShowJumpNext" class="ant-pagination-jump-next" title="向后 {{_pageSizeHalf}} 页" 
      (click)="_jump2Page(_currentPage+_pageSizeHalf)">
    <a></a>
  </li>
  <li *ngIf="_pageCount>=2" class="ant-pagination-item" title="最后一页: {{_pageCount}}"
      [class.ant-pagination-item-active]="_currentPage===_pageCount"
      (click)="_jump2Page(_pageCount)">
    <a>{{_pageCount}}</a>
  </li>
  <li class="ant-pagination-next" title="下一页"
      [class.ant-pagination-disabled]="_currentPage===_pageCount"
      (click)="_jump2Page(_currentPage+1)">
    <a></a>
  </li>
  <div class="ant-pagination-options">
    <nz-select
      *ngIf="showSizeChanger"
      class="ant-pagination-options-size-changer"
      [nzSize]="nzSize =='small'?'small':''"
      [ngModel]="_pageSize"
      (ngModelChange)="_pageSizeChange($event)">
      <nz-option
        *ngFor="let option of _pageSizeOptions"
        [nzLabel]="option+ '条/页'"
        [nzValue]="option">
      </nz-option>
    </nz-select>
  </div>
  <span class="ant-pagination-total-text" *ngIf="showTotal">共 {{_total}} 条</span>
  <div class="ant-pagination-options-quick-jumper" *ngIf="showQuickJumper">
    跳至<input [(ngModel)]="currentPage">页
  </div>
</ul>

<ul class="ant-pagination ant-pagination-simple" *ngIf="simpleType">
  <li
    title="上一页"
    class="ant-pagination-prev"
    (click)="_jump2Page(_currentPage-1)"
    [class.ant-pagination-disabled]="_currentPage===1">
    <a></a>
  </li>
  <li [attr.title]="_currentPage +'/'+ _pageCount" class="ant-pagination-simple-pager">
    <input [(ngModel)]="currentPage" size="3"><span class="ant-pagination-slash">／</span>{{_pageCount}}
  </li>
  <li
    title="下一页"
    class="ant-pagination-next"
    (click)="_jump2Page(_currentPage+1)"
    [class.ant-pagination-disabled]="_currentPage===_pageCount">
    <a></a>
  </li>
</ul> `,
  styles: [`.ant-pagination {
  font-size: 12px;
}
.ant-pagination:after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.ant-pagination-total-text {
  display: inline-block;
  vertical-align: middle;
  height: 28px;
  line-height: 28px;
  margin-right: 8px;
}
.ant-pagination-item {
  cursor: pointer;
  border-radius: 4px;
  user-select: none;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  list-style: none;
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  margin-right: 8px;
  font-family: Arial;
  outline: 0;
}
.ant-pagination-item a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.65);
  transition: none;
  margin: 0 6px;
}
.ant-pagination-item:focus,
.ant-pagination-item:hover {
  transition: all .3s;
  border-color: #108ee9;
}
.ant-pagination-item:focus a,
.ant-pagination-item:hover a {
  color: #108ee9;
}
.ant-pagination-item-active {
  background-color: #108ee9;
  border-color: #108ee9;
}
.ant-pagination-item-active:focus,
.ant-pagination-item-active:hover {
  background-color: #49a9ee;
  border-color: #49a9ee;
}
.ant-pagination-item-active a,
.ant-pagination-item-active:focus a,
.ant-pagination-item-active:hover a {
  color: #fff;
}
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  outline: 0;
}
.ant-pagination-jump-prev:after,
.ant-pagination-jump-next:after {
  content: "•••";
  display: block;
  letter-spacing: 2px;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
}
.ant-pagination-jump-prev:focus:after,
.ant-pagination-jump-next:focus:after,
.ant-pagination-jump-prev:hover:after,
.ant-pagination-jump-next:hover:after {
  color: #108ee9;
  display: inline-block;
  font-size: 12px;
  font-size: 8px \9;
  transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  letter-spacing: -1px;
  font-family: "anticon";
}
:root .ant-pagination-jump-prev:focus:after,
:root .ant-pagination-jump-next:focus:after,
:root .ant-pagination-jump-prev:hover:after,
:root .ant-pagination-jump-next:hover:after {
  filter: none;
}
:root .ant-pagination-jump-prev:focus:after,
:root .ant-pagination-jump-next:focus:after,
:root .ant-pagination-jump-prev:hover:after,
:root .ant-pagination-jump-next:hover:after {
  font-size: 12px;
}
.ant-pagination-jump-prev:focus:after,
.ant-pagination-jump-prev:hover:after {
  content: "\\e620\\e620";
}
.ant-pagination-jump-next:focus:after,
.ant-pagination-jump-next:hover:after {
  content: "\\e61f\\e61f";
}
.ant-pagination-prev,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  margin-right: 8px;
}
.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  font-family: Arial;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  list-style: none;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  transition: all .3s;
  display: inline-block;
  vertical-align: middle;
}
.ant-pagination-prev,
.ant-pagination-next {
  border: 1px solid #d9d9d9;
  background-color: #fff;
  outline: 0;
}
.ant-pagination-prev a,
.ant-pagination-next a {
  color: rgba(0, 0, 0, 0.65);
  outline: none;
}
.ant-pagination-prev a:after,
.ant-pagination-next a:after {
  display: inline-block;
  font-size: 12px;
  font-size: 8px \9;
  transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: block;
  height: 26px;
  line-height: 26px;
  font-family: "anticon";
  text-align: center;
}
:root .ant-pagination-prev a:after,
:root .ant-pagination-next a:after {
  filter: none;
}
:root .ant-pagination-prev a:after,
:root .ant-pagination-next a:after {
  font-size: 12px;
}
.ant-pagination-prev:focus,
.ant-pagination-next:focus,
.ant-pagination-prev:hover,
.ant-pagination-next:hover {
  border-color: #108ee9;
}
.ant-pagination-prev:focus a,
.ant-pagination-next:focus a,
.ant-pagination-prev:hover a,
.ant-pagination-next:hover a {
  color: #108ee9;
}
.ant-pagination-prev a:after {
  content: "\\e620";
  display: block;
}
.ant-pagination-next a:after {
  content: "\\e61f";
  display: block;
}
.ant-pagination-disabled {
  cursor: not-allowed;
}
.ant-pagination-disabled:hover {
  border-color: #d9d9d9;
}
.ant-pagination-disabled:hover a {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-pagination-disabled a {
  color: rgba(0, 0, 0, 0.25);
}
.ant-pagination-slash {
  margin: 0 10px 0 5px;
}
.ant-pagination-options {
  display: inline-block;
  vertical-align: middle;
  margin-left: 16px;
}
.ant-pagination-options-size-changer {
  display: inline-block;
  margin-right: 8px;
}
.ant-pagination-options-quick-jumper {
  display: inline-block;
  height: 28px;
  line-height: 28px;
  vertical-align: middle;
}
.ant-pagination-options-quick-jumper input {
  position: relative;
  display: inline-block;
  padding: 4px 7px;
  width: 100%;
  height: 28px;
  cursor: text;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
  margin: 0 8px;
  width: 50px;
}
.ant-pagination-options-quick-jumper input::-moz-placeholder {
  color: rgba(0, 0, 0, 0.25);
  opacity: 1;
}
.ant-pagination-options-quick-jumper input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-pagination-options-quick-jumper input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-pagination-options-quick-jumper input:hover {
  border-color: #49a9ee;
}
.ant-pagination-options-quick-jumper input:focus {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-pagination-options-quick-jumper input-disabled {
  background-color: #f7f7f7;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}
.ant-pagination-options-quick-jumper input-disabled:hover {
  border-color: #e2e2e2;
}
textarea.ant-pagination-options-quick-jumper input {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}
.ant-pagination-options-quick-jumper input-lg {
  padding: 6px 7px;
  height: 32px;
}
.ant-pagination-options-quick-jumper input-sm {
  padding: 1px 7px;
  height: 22px;
}
.ant-pagination-simple .ant-pagination-prev,
.ant-pagination-simple .ant-pagination-next {
  border: 0;
  height: 24px;
  line-height: 24px;
  margin: 0;
  font-size: 18px;
}
.ant-pagination-simple .ant-pagination-simple-pager {
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
.ant-pagination-simple .ant-pagination-simple-pager input {
  margin: 0 8px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  outline: none;
  padding: 5px 8px;
  height: 24px;
  text-align: center;
  transition: border-color 0.3s;
}
.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #108ee9;
}
.ant-pagination.mini .ant-pagination-total-text {
  height: 20px;
  line-height: 20px;
}
.ant-pagination.mini .ant-pagination-item {
  border: 0;
  margin: 0;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
}
.ant-pagination.mini .ant-pagination-prev,
.ant-pagination.mini .ant-pagination-next {
  margin: 0;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  border: 0;
}
.ant-pagination.mini .ant-pagination-prev a:after,
.ant-pagination.mini .ant-pagination-next a:after {
  height: 20px;
  line-height: 20px;
}
.ant-pagination.mini .ant-pagination-jump-prev,
.ant-pagination.mini .ant-pagination-jump-next {
  height: 20px;
  line-height: 20px;
}
.ant-pagination.mini .ant-pagination-options {
  margin-left: 8px;
}
.ant-pagination.mini .ant-pagination-options-quick-jumper {
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
}
.ant-pagination.mini .ant-pagination-options-quick-jumper input {
  padding: 1px 7px;
  height: 22px;
  width: 44px;
}
@media only screen and (max-width: 1024px) {
  .ant-pagination-item-after-jump-prev,
  .ant-pagination-item-before-jump-next {
    display: none;
  }
}
`]
  // encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnInit {
  private _currentPage = 1
  private _pageSize = 10
  private _pageSizeOptions = [10, 20, 30, 50]
  private _total = 0
  private _showSizeChanger: boolean
  private _showQuickJumper: boolean
  private _showTotal: boolean
  private _pageCount: any // 总页数
  private _isShowJumpPrev = false // 是否显示“往前x页”
  private _isShowJumpNext = false // 是否显示“往后x页”
  private _renderPages = [] // 需要显示的页码
  private _simpleType = false // 设置为简单模式
  private _nzSize = '' // 是否使用mini版本
  private _el: HTMLElement

  /**
   * 当前页码
   */
  @Input()
  get currentPage () {
    return this._currentPage
  }
  set currentPage (value: number){
    value -= 0
    if ((typeof value !== 'number') ||  (value === this._currentPage)) {
      return
    }
    if (value > this._pageCount || value < 1) {
      return
    }
    this._currentPage = value
    this._resetRenderPages()
  }

  /**
   * 数据总数
   */
  @Input()
  get total () {
    return this._total
  }
  set total(value: number){
    if ((typeof value !== 'number') ||  (value === this._total)) {
      return
    }
    this._total = value
    this._resetRenderPages()
  }

  /**
   * 每页数据条数
   */
  @Input()
  get pageSize(){
    return this._pageSize
  }
  set pageSize(value: number){
    this._pageSize = value || this.pageSizeOptions[0]
    this._resetRenderPages()
  }

  /**
   * 每页数据条数配置可选项
   */
  @Input()
  get pageSizeOptions(){
    return this._pageSizeOptions
  }
  set pageSizeOptions(list: Array<number>){
    if (list.length > 0) {
      this._pageSizeOptions = list
      this._resetRenderPages()
    }
  }

  /**
   * 是否可以更改每页数据条数
   */
  @Input()
  get showSizeChanger(){
    return this._showSizeChanger
  }
  set showSizeChanger(value: boolean|string) {
    if (value === '') {
      this._showSizeChanger = true
    } else {
      this._showSizeChanger = value as boolean
    }
  }

  /**
   * 是否显示快速跳页
   */
  @Input()
  set showQuickJumper(value: boolean|string) {
    if (value === '') {
      this._showQuickJumper = true
    } else {
      this._showQuickJumper = value as boolean
    }
  }
  get showQuickJumper() {
    return this._showQuickJumper
  }

  /**
   * 是否显示数据总数
   */
  @Input()
  set showTotal(value: boolean|string) {
    if (value === '') {
      this._showTotal = true;
    } else {
      this._showTotal = value as boolean;
    }
  }
  get showTotal() {
    return this._showTotal
  }

  /**
   * 简单模式开关
   */
  @Input()
  set simpleType(value: boolean|string) {
    if (value === '') {
      this._simpleType = true;
    } else {
      this._simpleType = value as boolean;
    }
  }
  get simpleType() {
    return this._simpleType
  }

  /**
   * 迷你模式开关
   */
  @Input()
  set nzSize(value: string) {
    this._nzSize = value;
  }
  get nzSize() {
    return this._nzSize
  }

  /**
   * 切换页码时触发
   */
  @Output() onCurrentPageChange = new EventEmitter()

  /**
   * 切换每页数据条数时触发
   */
  @Output() onPageSizeChange = new EventEmitter()

  constructor(private _elementRef: ElementRef) {
    this._el = this._elementRef.nativeElement;
  }

  ngOnInit() {
    if (this._pageSizeOptions.findIndex(value => value === this.pageSize) < 0) {
      this._pageSizeOptions.push(this.pageSize)
    }
    this._pageSizeOptions.sort((a, b) => a - b)
    this._resetRenderPages()
  }

  /**
   * 计算要渲染的中间页码
   */
  private _resetRenderPages() {
    this._pageCount = Math.ceil(this._total / this._pageSize)
    this._isShowJumpPrev = this._pageCount > 5 && (this._currentPage - 2) > 1
    this._isShowJumpNext = this._pageCount > 5 && (this._currentPage + 2) < (this._pageCount - 1)
    let pages = []
    if (this._pageCount > 2) { // 两页以上才显示中间页码
      let index = 1
      if (this._currentPage - 2 >= 1) {
        index = this._currentPage - 2
      }
      if (this._pageCount - this._currentPage <= 2) {
        index = this._pageCount - 4
      }
      if (index < 1) {
        index = 1
      }
      do {
        pages.push(index)
        index++
      } while (index < this._pageCount && pages.length < 5)
      if (pages[0] === 1) {
        pages.shift()
      }
      if (pages[pages.length - 1] === this._pageCount) {
        pages.pop()
      }
      this._renderPages = pages
    }
  }
  private _jump2Page(value: number) {
    if (value > this._pageCount) {
      this.currentPage = this._pageCount
    } else if (value < 1) {
      this.currentPage = 1
    } else {
      this.currentPage = value
    }
    this.onCurrentPageChange.emit(this.currentPage)
  }
  private _pageSizeChange($event) {
    this.pageSize = $event;
    this.onPageSizeChange.emit($event);
  }
  private get _pageSizeHalf(){
    return Math.round(this._pageSize / 2);
  }
}
